module.exports = __webpack_public_path__ + "static/media/Felt Friends-100.4f9c23fa.webp";